import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { StudioSignupFlow } from './components/signup/studio-signup-flow';
import { SuperAdminRoute } from './components/auth/super-admin-route';
import { SuperAdminLayout } from './components/layout/super-admin-layout';
import { SuperAdminDashboard } from './components/superadmin/super-admin-dashboard';
import { Unauthorized } from './components/auth/unauthorized';
import { Login } from './components/auth/login';
import { PlatformEquipmentPageFixed as PlatformEquipmentPage } from './features/platformEquipment/PlatformEquipmentPageFixed';
import { PlatformExercisesPage } from './features/platformExercises';
import { PlatformBlocksPage } from './features/platformBlocks';
import { PlatformTemplatesPage } from './features/platformTemplates';
import { RoleBasedRedirect } from './components/auth/RoleBasedRedirect';
import { StudioAdminLayout } from './components/layout/StudioAdminLayout';
import { StudioAdminRoute } from './components/auth/StudioAdminRoute';
import { StudioDashboardPage } from './features/studioDashboard';
import { SessionDetailPage } from './features/sessionDetail';
import { ClientListPage } from './features/studioClients';
import { ClientDetailPage } from './features/studioClients/ClientDetailPage';
import { SessionPlanningPage } from './features/studioSessionPlanning';
import './App.css';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<StudioSignupFlow />} />
      <Route path="/auth/signup" element={<StudioSignupFlow />} />
      <Route path="/unauthorized" element={<Unauthorized />} />

      {/* Role-based redirect from root */}
      <Route path="/" element={<RoleBasedRedirect />} />

      {/* SuperAdmin Routes */}
      <Route 
        path="/superadmin/*" 
        element={
          <SuperAdminRoute>
            <SuperAdminLayout />
          </SuperAdminRoute>
        }
      >
        <Route index element={<SuperAdminDashboard />} />
        <Route path="equipment" element={<PlatformEquipmentPage />} />
        <Route path="exercises" element={<PlatformExercisesPage />} />
        <Route path="blocks" element={<PlatformBlocksPage />} />
        <Route path="templates" element={<PlatformTemplatesPage />} />
      </Route>

      {/* StudioAdmin Routes */}
      <Route 
        path="/studio/*" 
        element={
          <StudioAdminRoute>
            <StudioAdminLayout />
          </StudioAdminRoute>
        }
      >
        <Route index element={<StudioDashboardPage />} />
        <Route path="sessions/:sessionId" element={<SessionDetailPage />} />
        <Route path="clients" element={<ClientListPage />} />
        <Route path="clients/:clientId" element={<ClientDetailPage />} />
        <Route path="planning" element={<SessionPlanningPage />} />
      </Route>

      {/* Fallback route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
